// extracted by mini-css-extract-plugin
export default {"root":"_3F2BZ","muroIcon":"_1cfOd","newIcon":"_2jlLX"};